import React, { useState } from 'react';
import { Col } from 'react-bootstrap';
import { Field } from 'redux-form';
import { FormGroupRow, InfoLabel } from '../../../../../../common/components';
import SelectField from '../../../../../../common/components/ReduxFormField/SelectField';
import { CheckboxGroup } from '../../../../../../common/components/ReduxFormField';
import FormControlInput from '../../../../../../common/components/HorizontalFormControl/Input';

const OptionSingleRateWithMultiplier = ({ rate, multiplier, input, isViewOnly }) => {
  const [ratePart, setRatePart] = useState(rate);
  const rateType = input.value.rate_type;
  const name = input.name;
  const handleRateChange = (value) => {
    setRatePart(value);
    const newMultiplierRate = `${value}${multiplier}`;
    if (newMultiplierRate.match(/^(\d+(?:\.\d+)?)( \* \w+)$/)) {
      const newRate = {
        ...input.value,
        rate: `${value}${multiplier}`,
      };
      input.onChange(newRate);
    }
  };

  return (
    <>
      <Col sm={5}>
        <FormGroupRow label={'Rate:'} labelSize={4} fieldSize={8}>
          {!isViewOnly ? (
            <FormControlInput
              value={ratePart}
              onChange={handleRateChange}
              addonAfter={<span>{multiplier}</span>}
              percentage={rateType === 'loading'}
              currency={rateType === 'fixed'}
            />
          ) : (
            <InfoLabel value={`£${input.value.rate}`} />
          )}
        </FormGroupRow>
      </Col>
      <Col sm={3}>
        <Field
          name={`${name}.rate_type`}
          label={'Rate Type:'}
          fieldSize={4}
          labelSize={4}
          component={isViewOnly ? InfoLabel : SelectField}
          isDisabled={isViewOnly}
          //onChange={ this.handleChange }
          options={[
            { value: 'loading', label: 'Loading' },
            { value: 'fixed', label: 'Fixed' },
          ]}
        />
      </Col>
      <Col sm={3}>
        {isViewOnly ? (
          <InfoLabel
            labelSize={4}
            label={'Auto-include:'}
            value={input.value.auto_include ? 'Yes' : 'No'}
          />
        ) : (
          <Field
            name={`${name}.auto_include`}
            label={'Auto-include:'}
            labelSize={4}
            fieldSize={4}
            noFormGroup
            component={CheckboxGroup}
            options={[{ label: '', value: true }]}
          />
        )}
      </Col>
    </>
  );
};
export default OptionSingleRateWithMultiplier;
